import { render } from "./FolderInfo.vue?vue&type=template&id=06ecab28&scoped=true"
import script from "./FolderInfo.vue?vue&type=script&lang=js"
export * from "./FolderInfo.vue?vue&type=script&lang=js"

import "./FolderInfo.vue?vue&type=style&index=0&id=06ecab28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ecab28"],['__file',"src/components/FolderInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06ecab28"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06ecab28', __exports__)) {
    api.reload('06ecab28', __exports__)
  }
  
  module.hot.accept("./FolderInfo.vue?vue&type=template&id=06ecab28&scoped=true", () => {
    api.rerender('06ecab28', render)
  })

}


export default __exports__